import { FC, useMemo } from 'react'
import { WeekStacked } from './views/week/WeekStacked'
import { useSchedulerPropsContext } from './context/schedulerContext'
import { DayStacked } from './views/day/DayStacked'
import { OuterTable } from './components/OuterTable/OuterTable'
import { Scheduler } from './components/Scheduler/Scheduler'

export interface SchedulerEventsDisplayProps {}

export const SchedulerStackDisplay: FC<
  SchedulerEventsDisplayProps
> = () => {
  const { view } = useSchedulerPropsContext()

  const Views = useMemo(() => {
    switch (view) {
      case 'week':
        return <WeekStacked />
      case 'day':
        return <DayStacked />
      default:
        return ''
    }
  }, [view])

  return (
    <Scheduler>
      <OuterTable>{Views}</OuterTable>
    </Scheduler>
  )
}
